import { render, staticRenderFns } from "./GoodReports.vue?vue&type=template&id=6033faca&"
import script from "./GoodReports.vue?vue&type=script&lang=js&"
export * from "./GoodReports.vue?vue&type=script&lang=js&"
import style0 from "./GoodReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports